import { IDetailedUser, IDetailedUserPersistence } from '../interfaces';

const getRoleFromAdmin = (admin: number): IDetailedUser['role'] => {
  switch (admin) {
    case 1:
      return 'admin';
    case 2:
      return 'warehouseman';
    case 3:
      return 'back-office';
    case 4:
      return 'partner';
    default:
      return 'user';
  }
};

export class DetailedUserMapper {
  public static toDomain(raw: IDetailedUserPersistence): IDetailedUser {
    return {
      id: raw.data.id,
      firstname: raw.data.name,
      lastname: raw.data.surname,
      fullName: raw.data.user_name,
      email: raw.data.email,
      phoneNumber: raw.data.number ?? null,
      gender: raw.data.gender,
      birthDate: raw.data.birth_date ?? null,
      address: raw.data.address ?? null,
      branch: {
        id: raw.data.branch_id ?? null,
        name: raw.data.branch_name ?? null,
      },
      adminBranchId: raw.data.admin_branch_id ?? null,
      adminBranchName: raw.data.admin_branch_name ?? null,
      adminCompanyName: raw.data.admin_company_name ?? null,
      cashboxId: raw.data.cashbox_id ?? null,
      passport: {
        number: raw.data.passport_number ?? null,
        secret: raw.data.passport_secret ?? null,
      },
      balance: {
        usd: raw.widget?.balance?.usd ?? 0,
        try: raw.widget?.balance?.try ?? 0,
      },
      counts: {
        declarations: {
          all: raw.data.declaration?.all ?? 0,
          handedOver: raw.data.declaration?.delivered ?? 0,
        },
        couriers: {
          all: raw.data.courier?.all ?? 0,
          handedOver: raw.data.courier?.delivered ?? 0,
        },
        orders: {
          all: raw.data.order?.all ?? 0,
          handedOver: raw.data.order?.delivered ?? 0,
        },
        transactions: {
          income: raw.data.in ?? 0,
          outcome: raw.data.out ?? 0,
        },
      },
      debt: {
        usd: raw.credit_usd ?? 0,
        try: raw.credit ?? 0,
      },
      spending: {
        currentMonth: {
          usd: raw.widget?.this?.usd ?? 0,
          try: raw.widget?.this?.try ?? 0,
        },
      },
      cashback: {
        currentCashback: raw.cashback?.currentCashback ?? 0,
        totalCashbackApproved: raw.cashback?.totalCashbackApproved ?? 0,
        totalCashbackPending: raw.cashback?.totalCashbackPending ?? 0,
      },
      discounts: (raw.discounts ?? []).map((d) => ({
        id: d.id,
        countryId: d.country_id,
        countryName: d.country_name,
        discount: d.discount,
        causerName: d.causer_name,
        descr: d.descr,
        discountDate: d.discount_date,
      })),
      role: getRoleFromAdmin(raw.data.admin),
      isBlocked: !!raw.data.blocked,
      createdAt: raw.data.created_at,
      sendSms: !!raw.data.send_sms,
      sendEmail: !!raw.data.send_mail,
    };
  }
}
